import { getProfileTable } from "src/Requests/deltaHedgeBackTest";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { TableAdditional } from "./Additional";

interface IProps {
  refreshFlag: boolean;
}

const ProfileTable = ({ refreshFlag }: IProps) => {
  return (
    <TableTemplate
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={TableAdditional}
          refreshFlag={refreshFlag}
        />
      )}
      getDataTable={getProfileTable}
    />
  );
};

export default ProfileTable;
